import CardContent from "@mui/material/CardContent";
import React, { useContext, useEffect, useState } from "react";
import { Markup } from "interweave";
import singleFrame from "../../../Assets/Images/Normal-User/Single-frame.png";

import paytm from "../../../Assets/Images/Payment-img/Paytm_Logo.png";
import strip from "../../../Assets/Images/Payment-img/strip.png";
import shujoPay from "../../../Assets/Images/Payment-img/shurjo-pay.jpeg";
import ipay88 from "../../../Assets/Images/Payment-img/ipay88.png";

import axios from "axios";
import swal from "sweetalert";

import { useHistory } from "react-router-dom";
import { Card, Form, Modal } from "react-bootstrap";
import { usePaytm } from "../../../CustomHooks/usePaytm";
import StripeModal from "../../Modal/PaymentModal/StripeModal";
import { useStripePayment } from "../../../CustomHooks/useStripePayment";
import { useShurjoPay } from "../../../CustomHooks/useShurjoPay";
import { serverInfo } from "../../../App";
import { LocationContext } from "../../../CustomHelper/Helper";
import { faSlash } from "@fortawesome/free-solid-svg-icons";
import {useSSLCommerzPay} from "../../../CustomHooks/useSSLCommerzPay";
import {usePhonePePay} from "../../../CustomHooks/usePhonePePay";
import {Box, Button, TextField, Typography} from "@mui/material";
import PaymentAgreeModal from "../../CustomModal/PaymentAgreeModal";
import {Grid} from "@material-ui/core";

export default function MyVerticallyCenteredModal(props) {
  console.log({props});
  const { shurjoFrormData, setShurjoFrormData } = useContext(serverInfo);
  const { myLocation } = useContext(LocationContext);

  const [userWallet, setGetUserWallet] = useState();
  const [walletButton, setWalletButton] = useState(false);
  const [tnc, setTnc] = useState("");
  const [agreeModal, setAgreeModal] = useState({isOpen:false,isAgree:false,paymentBy:''});

  const user_id = localStorage.getItem("auth_id");

  const { shurjoPayMakePayment, shurjoBuffer } = useShurjoPay({
    amount: props?.fee,
    event_type: props?.event_type,
    event_id: props?.event_id,
    client_ip: "web",
  });

  const { sslCommerzBuffer,sslCommerzPayMakePayment } = useSSLCommerzPay({
    amount: props?.fee,
    event_type: props?.event_type,
    event_id: props?.event_id
  });

  const { phonePeBuffer,phonePePayMakePayment } = usePhonePePay({
    amount: props?.fee,
    event_type: props?.event_type,
    event_id: props?.event_id
  });

  const history = useHistory();
  const [stripeShow, setStripeShow] = useState(false);
  const { makePaytmPayment } = usePaytm({
    amount: props?.fee,
    redirectTo: props?.redirectTo,
    type: props?.event_type,
    event_id: props?.event_id,
  });
  const [regBuffer, setRegBuffer] = useState(false);

  const {
    stripeMakePayment,
    stripeBuffer,
    clientSecret,
    publicKey,
    error,
    stripeModalShow,
    setStripeModalShow,
  } = useStripePayment({
    amount: props?.quantity > 0 ? props?.quantity * props?.baseFee : props.baseFee,
    event_type: props?.event_type,
    event_id: props?.event_id,
  });

  const cardInfoSubmit = (payment_method) => {
    setRegBuffer(true);

    localStorage.setItem("amount",props?.baseFee);
    localStorage.setItem("event_id",props?.event_id);
    localStorage.setItem("event_type",props?.event_type);
    localStorage.setItem("redirectTo",props?.redirectTo);

    const data = {
      quantity: props?.quantity,
      event_id: props?.event_id,
      event_registration_id: props?.event_registration_id
        ? props?.event_registration_id
        : null,
      notification_id: props?.notification_id ? props?.notification_id : null,
      model_name: props?.event_type,
      fee: props?.baseFee,
      start_time: props?.start_time,
      end_time: props?.end_time,
      payment_method: payment_method,
    };

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/user/event-register`, data).then((res) => {
        if (res.data.status == 200 && res.data.payment_method == "wallet") {
          history.push("/" + props?.redirectTo);
        }
      });
    });
  };

  /**
   * ipay88 make payment
   */
  const ipay88MakePayment = () => {
    window.location.replace(
      `https://backend.hellosuperstars.com/ipay88-make-payment/${user_id}/${props?.fee}/${props?.event_type}/${props?.event_id}/0/web`
    );
  };

  useEffect(() => {
    axios.get(`/api/user/wallet/details`).then((res) => {
      if (res.status === 200) {
        setGetUserWallet(res.data.userWallet);
      }
    });
  }, []);

  useEffect(() => {
    console.log('myLocation?.countryCode', myLocation?.countryCode);
    if (!myLocation?.countryCode) {
      return;
    }

    const getPaymentInfo = async () => {
      try {
        const resolvedEventId =
          props?.event_type === "greeting" ||
          props?.event_type === "plan" ||
          props?.event_type === "marketplace" ||
          props?.event_type === "auction"
            ? props?.event_id
            : props?.eventId || props?.event_id;

        const resolvedEventType = props?.model_name || props?.event_type;
         console.log('resolvedEventId', resolvedEventId);
         console.log('resolvedEventType', resolvedEventType);
        const paymentInfoUrl =
          `/api/terms-condition/${myLocation?.countryCode}/payment` +
          `?event_id=${encodeURIComponent(resolvedEventId ?? "")}&event_type=${encodeURIComponent(resolvedEventType ?? "")}`;
// console.log('paymentInfoUrl', paymentInfoUrl);
        const res = await axios.get(paymentInfoUrl);
        setTnc(res?.data?.data?.details ?? res?.data?.data[0]?.details ?? "");
        // console.log('Payment info response:', res?.data?.data);
      } catch (err) {
        console.log(err);
        setTnc("");
      }
    };

    getPaymentInfo();
  }, [
    myLocation?.countryCode,
    props?.event_type,
    props?.event_id,
    props?.eventId,
    props?.model_name,
  ]);




    useEffect(() => {
        if (agreeModal.isAgree) {
            if (agreeModal.paymentBy == 'stripe') {
                cardInfoSubmit();
                history.push("/stripe-payment");
            }
            if (agreeModal.paymentBy == 'bdpayment' ) {
                cardInfoSubmit();
                sslCommerzPayMakePayment();
            }
            if (agreeModal.paymentBy == 'indPayment') {
                phonePePayMakePayment();
                cardInfoSubmit();
            }
            if (agreeModal.paymentBy == 'mymPayment') {
                ipay88MakePayment();
                cardInfoSubmit();
            }
        }
    }, [agreeModal])


  // global payment getways
  const globalPayment = () => {
    return (
      <>
        {/* stripe */}
        <div
          className="item"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setAgreeModal({...agreeModal,isOpen: true,paymentBy:'stripe'})

          }}
        >
          <img
            src={strip}
            alt=""
            className="img-fluid payment-img"
          />
        </div>
      </>
    )
  }

  // bangla deshi payment getways
  const bdpayment = () => {
    return (
      <>
        {/* shurjo pay */}
        <div
          className="item"
          style={{ cursor: "pointer" }}
          onClick={() => {
              setAgreeModal({...agreeModal,isOpen: true,paymentBy:'bdpayment'})


          }}
        >
          <img
            src={shujoPay}
            alt=""
            className="img-fluid payment-img"
          />
        </div>

        {globalPayment()}
      </>
    )
  }

  //indian payment getways
  // const indPayment = () => {
  //
  //   return (
  //     <>
  //       {/* paytem  */}
  //       <div
  //         className="item"
  //         style={{ cursor: "pointer" }}
  //         onClick={() => {
  //           makePaytmPayment();
  //           cardInfoSubmit();
  //         }}
  //       >
  //         <img
  //           src={paytm}
  //           alt=""
  //           className="img-fluid payment-img"
  //         />
  //       </div>
  //
  //       {/* stripe */}
  //       {globalPayment()}
  //
  //     </>
  //   )
  //
  // }
  const indPayment = () => {

    return (
      <>
        {/* paytem  */}
        <div
          className="item"
          style={{ cursor: "pointer" }}
          onClick={() => {
              setAgreeModal({...agreeModal,isOpen: true,paymentBy:'indPayment'})


          }}
        >
          <img
            src={paytm}
            alt=""
            className="img-fluid payment-img"
          />
        </div>

        {/* stripe */}
        {globalPayment()}

      </>
    )

  }

  // malaysia payment getways
  const mymPayment = () => {
    return (
      <>
        {/* ipay88  */}
        <div
          className="item"
          style={{ cursor: "pointer" }}
          onClick={() => {
              setAgreeModal({...agreeModal,isOpen: true,paymentBy:'mymPayment'})


          }}
        >
          <img
            src={ipay88}
            alt=""
            className="img-fluid payment-img"
          />
        </div>

        {/* stripe */}
        {globalPayment()}
      </>
    )
  }

  const renderPaymentGetways = () => {
    
    if (myLocation?.countryCode == "BD") {

      return bdpayment();

    } else if (myLocation?.countryCode == 'IN') {

      return indPayment();

    } else if (myLocation?.countryCode == 'MY') {

      return mymPayment();

    } else {

      return globalPayment();

    }


  }

  return (
      <>

          <PaymentAgreeModal
              sx={{
                  backgroundColor: "#25272b",
                  p: 3,
                  py: 2,
                  height:'70vH',overflow:'auto',
                  width: {xs: "90%", sm: "70%"},
                  color:'rgb(194, 194, 194)'
              }}
              open={agreeModal.isOpen}
          >
              <Grid >
                  <Typography
                      sx={{
                          fontSize: "1.2rem",
                          fontweight: "bold",
                      }}
                  >
                      Terms & Condition
                  </Typography>
              </Grid>
              <Grid
                  sx={{
                      mt: 2,
                  }}>
                  <Markup content={tnc}></Markup>
              </Grid>
              <div><Grid container alignItems={"center"} spacing={4}>
                  <Grid style={{textAlign:'center'}} item xs={6}>
                      <button style={{background:'white'}}
                          onClick={() => {
                              setAgreeModal({...agreeModal, isOpen: false, isAgree: false})
                          }}
                          className="btn btn-register fw-bold"
                      >
                          Cancel
                      </button>
                  </Grid>
                  <Grid style={{textAlign:'center'}} item xs={6}>
                      <button
                          onClick={() => {
                              setAgreeModal({...agreeModal, isOpen: false, isAgree: true})
                          }}
                          className="btn btn-register fw-bold"
                      >
                          Agree
                      </button>
                  </Grid>
              </Grid></div>
          </PaymentAgreeModal>


      <Modal>
        <Modal.Body>
          <Card style={{ backgroundColor: "#25272b" }} sx={{ minWidth: 275 }}>
            <div
                onClick={props?.onHide}
                className="d-flex justify-content-end p-2"
            >
            </div>
          </Card>
        </Modal.Body>
      </Modal>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <Card style={{ backgroundColor: "#25272b" }} sx={{ minWidth: 275 }}>
            <div
              onClick={props?.onHide}
              className="d-flex justify-content-end p-2"
            >
              <div className="closeNotificationDrop text-center">X</div>
            </div>

            <CardContent>
              <div className="text-center image-middle">
                <img className="singleFrame-style" src={singleFrame} alt="" />
                <h3 className="centered">Payment Method</h3>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  paddingTop: "50px",
                  paddingBottom: "50px",
                  minHeight: "200px",
                  flexWrap: "wrap",
                }}
              >
                {regBuffer || sslCommerzBuffer ? (
                  <div class="spinner-border text-warning" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                ) : (
                  <>

                    {renderPaymentGetways()}

                  </>
                )}
              </div>
              <div>
                {/* <button  onClick={formSubmit}  className="my-3 btn btn-gold">Confirm Payment</button> */}
                <div className="row my-2">
                  {/*<div className="col-md-4 mx-auto">*/}
                  {/*  <button className="btn btn-info btnTest rounded-3 w-100 fw-bold">*/}
                  {/*    Avaiable :*/}
                  {/*    {props?.event_type === "qna"*/}
                  {/*      ? userWallet?.qna*/}
                  {/*      : props?.event_type === "livechat"*/}
                  {/*        ? userWallet?.live_chats*/}
                  {/*        : props?.event_type === "learningSession"*/}
                  {/*          ? userWallet?.learning_session*/}
                  {/*          : props?.event_type === "greeting"*/}
                  {/*            ? userWallet?.greetings*/}
                  {/*            : props?.event_type === "meetup"*/}
                  {/*              ? userWallet?.meetup*/}
                  {/*              : props?.event_type === "audition"*/}
                  {/*                ? userWallet?.auditions*/}
                  {/*                : "00"}*/}
                  {/*  </button>*/}
                  {/*</div>*/}
                  {/*<div className="col-md-4 mx-auto">*/}
                  {/*  /!* <button*/}
                  {/*    className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*    onClick={() => cardInfoSubmit("wallet")}*/}
                  {/*  >*/}
                  {/*    Use wallet*/}
                  {/*  </button> *!/*/}
                  {/*  {props?.event_type === "qna" && userWallet?.qna > 0 ? (*/}
                  {/*    <button*/}
                  {/*      className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*      onClick={() => cardInfoSubmit("wallet")}*/}
                  {/*    >*/}
                  {/*      Use wallet*/}
                  {/*    </button>*/}
                  {/*  ) : props?.event_type === "livechat" &&*/}
                  {/*    userWallet?.live_chats > 0 ? (*/}
                  {/*    <button*/}
                  {/*      className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*      onClick={() => cardInfoSubmit("wallet")}*/}
                  {/*    >*/}
                  {/*      Use wallet*/}
                  {/*    </button>*/}
                  {/*  ) : props?.event_type === "learningSession" &&*/}
                  {/*    userWallet?.learning_session > 0 ? (*/}
                  {/*    <button*/}
                  {/*      className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*      onClick={() => cardInfoSubmit("wallet")}*/}
                  {/*    >*/}
                  {/*      Use wallet*/}
                  {/*    </button>*/}
                  {/*  ) : props?.event_type === "greeting" &&*/}
                  {/*    userWallet?.greetings > 0 ? (*/}
                  {/*    <button*/}
                  {/*      className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*      onClick={() => cardInfoSubmit("wallet")}*/}
                  {/*    >*/}
                  {/*      Use wallet*/}
                  {/*    </button>*/}
                  {/*  ) : props?.event_type === "meetup" &&*/}
                  {/*    userWallet?.meetup > 0 ? (*/}
                  {/*    <button*/}
                  {/*      className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*      onClick={() => cardInfoSubmit("wallet")}*/}
                  {/*    >*/}
                  {/*      Use wallet*/}
                  {/*    </button>*/}
                  {/*  ) : props?.event_type === "audition" &&*/}
                  {/*    userWallet?.auditions > 0 ? (*/}
                  {/*    <button*/}
                  {/*      className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*      onClick={() => cardInfoSubmit("wallet")}*/}
                  {/*    >*/}
                  {/*      Use wallet*/}
                  {/*    </button>*/}
                  {/*  ) : (*/}
                  {/*    <button*/}
                  {/*      className="btn btn-info btnTest rounded-3 w-100 fw-bold"*/}
                  {/*      disabled*/}
                  {/*    >*/}
                  {/*      Use wallet*/}
                  {/*    </button>*/}
                  {/*  )}*/}
                  {/*</div>*/}
                </div>
              </div>
            </CardContent>
          </Card>
        </Modal.Body>
      </Modal>
      <StripeModal
        show={stripeModalShow}
        onHide={() => setStripeModalShow(false)}
        amount={
          props?.quantity > 0 ? props?.quantity * props?.baseFee : props.baseFee
        }
        event_id={props?.event_id}
        event_type={props?.event_type}
        clientSecret={clientSecret}
        publicKey={publicKey}
      />
    </>
  );
}
